import storage from '@/utils/storage.js'
const state = {
  adminUser: storage.getLocal('userinfo') || null,
  selectLanguage: storage.getLocal('localeLaguage') ? storage.getLocal('localeLaguage').name : '한국어',
  elementLanguage: storage.getLocal('localeLaguage') ? storage.getLocal('localeLaguage').txt : 'ko',
  routes: null
}
export default state